<mat-card class="card">
  <mat-card-header>
    <mat-card-title>Personas</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="group" class="filter-form" (ngSubmit)="onSubmit()">
      <mat-form-field class="filter-type-select">
        <mat-label>Atributo</mat-label>
        <mat-select formControlName="subject">
          <mat-option *ngFor="let item of subjects" [value]="item.id">{{ item.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-value-input">
        <mat-label>Valor</mat-label>
        <input matInput formControlName="searchString">
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit"
              [class.spinner]="dataSource.isLoadingResults" class="button">
        Buscar
      </button>
    </form>
    <div class="mat-elevation-z8">
      @if (dataSource.isLoadingResults()) {
        <div class="example-loading-shade">
          @if (dataSource.isLoadingResults()) {
            <mat-spinner></mat-spinner>
          }
        </div>
      }
      <div class="table-container">
        <table mat-table class="client-search-table" matSort matSortActive="personName"
               matSortDisableClear
               matSortDirection="desc">
          <ng-container matColumnDef="identificationNumber">
            <th mat-header-cell *matHeaderCellDef> ID</th>
            <td mat-cell *matCellDef="let element"> {{ element.identificationNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="personName">
            <th mat-header-cell *matHeaderCellDef> Nombre</th>
            <td mat-cell *matCellDef="let element"> {{ element.fullName }}</td>
          </ng-container>
          <ng-container matColumnDef="isNaturalPerson">
            <th mat-header-cell *matHeaderCellDef> Persona Natural</th>
            <td mat-cell *matCellDef="let element"> {{ element.isNaturalPerson }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <div class="application-actions">
                <button mat-icon-button class="menu-button" matTooltip="Seleccionar">
                  <mat-icon>how_to_reg</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No hay personas</td>
          </tr>
        </table>
      </div>
      <mat-paginator [length]="dataSource.resultsLength()" [pageSize]="20"
                     [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                     aria-label="Páginas">
      </mat-paginator>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button color="primary" (click)="onClose()">Cerrar</button>
  </mat-card-actions>
</mat-card>
